const tokenKey = 'availora-access-token';
const contextKey = 'availora-active-context';

export function getAccessToken(): string | null {
  return sessionStorage.getItem(tokenKey);
}

export function setAccessToken(token: string): void {
  sessionStorage.setItem(tokenKey, token);
}

export function clearAuthStorage(): void {
  sessionStorage.removeItem(tokenKey);
  sessionStorage.removeItem(contextKey);
}

export function getStoredContextId(): string | null {
  return sessionStorage.getItem(contextKey);
}

export function setStoredContextId(contextId: string): void {
  sessionStorage.setItem(contextKey, contextId);
}
